module.exports = __webpack_public_path__ + "assets/img/2.de81da66.jpg";